import { getLabelOptions } from "labels/hosts";

const getDomain = () => {
  const { cookieDomain } = getLabelOptions();
  return cookieDomain;
};

export default getDomain;
